export default __webpack_public_path__ + "static/media/first_bg.38efa93a.webp";